import React from 'react';

import FieldText from '../common/FieldText';
import FieldTextArea from '../common/FieldTextArea';
import FieldDate from '../common/FieldDate';
import FieldSelect from '../common/FieldSelect';
import FieldMultiSelect from '../common/FieldMultiSelect';
import FieldMultiValue from '../common/FieldMultiValue';

class ProjectAddEditInfo extends React.Component {
  render() {
    const fields = this.props.model.fields;
    const project = this.props.project;
    const onValueChange = this.props.onValueChange;
    const inValid = this.props.inValid;
    return (
      <>
        <div className="formhead col-md-12"><h2>Project Information</h2></div>
        
        <FieldText key="project_id" id="project_id" field={fields.project_id}
          value={project.project_id} onValueChange={onValueChange} inValid={inValid} />

        <FieldText key="project_name" id="project_name" field={fields.project_name}
          value={project.project_name} onValueChange={onValueChange} inValid={inValid} />

        <FieldText key="developer_name" id="developer_name" field={fields.developer_name}
            value={project.developer_name} onValueChange={onValueChange} inValid={inValid} />

        <FieldText key="total_towers" id="total_towers" field={fields.total_towers}
            value={project.total_towers} onValueChange={onValueChange} inValid={inValid} />    

        <FieldMultiSelect key="amenities" id="amenities" field={fields.amenities} 
          value={project.amenities} onValueChange={onValueChange} inValid={inValid} />

        <FieldMultiSelect key="responsible_person" id="responsible_person"
            field={fields.responsible_person} value={project.responsible_person}
                onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="possession" id="possession" field={fields.possession}
            value={project.possession} onValueChange={onValueChange} inValid={inValid} />

        <FieldDate key="posession_date" id="posession_date" field={fields.posession_date}
          value={project.posession_date} onValueChange={onValueChange} inValid={inValid} />

        <FieldMultiSelect key="project_type" id="project_type"
          field={fields.project_type} value={project.project_type}
          onValueChange={onValueChange} inValid={inValid} />

        <FieldText key="total_land_parcel" id="total_land_parcel" field={fields.total_land_parcel}
            value={project.total_land_parcel} onValueChange={onValueChange} inValid={inValid} /> 

        <FieldText key="rera_num" id="rera_num" field={fields.rera_num}
            value={project.rera_num} onValueChange={onValueChange} inValid={inValid} /> 

        <FieldMultiSelect key="area" id="area"
          field={fields.area} value={project.area} onValueChange={onValueChange} 
          inValid={inValid} />

        <FieldTextArea key="description" id="description" field={fields.description}
            value={project.description} onValueChange={onValueChange} inValid={inValid} />

        <div className="formhead col-md-12"><h2>API Configurations</h2></div>

        <FieldMultiValue key="acres99_code" id="acres99_code" field={fields.acres99_code} value={project.acres99_code}
          onValueChange={onValueChange} inValid={inValid} />

        <FieldMultiValue key="acres99_project_name" id="acres99_project_name" field={fields.acres99_project_name} value={project.acres99_project_name}
          onValueChange={onValueChange} inValid={inValid} />

        <FieldMultiValue key="magicbrics_code" id="magicbrics_code" field={fields.magicbrics_code} value={project.magicbrics_code}
          onValueChange={onValueChange} inValid={inValid} />
          
      </>
    );
  }
}

export default ProjectAddEditInfo;